import { FEATURES } from '@constants/Text'

export const complianceRoutes = (show = {}, currentUser) => {
  const canAccessCompliance = !!show[FEATURES.COMPLIANCE]
  const optionsRoutes = [
    { title: 'Bem-vindo', name: 'compliance.welcome', hasAccess: true },
    {
      title: 'Visão Geral',
      name: 'compliance.overview',
      hasAccess: canAccessCompliance,
    },
    { title: 'KYC/PLD', name: 'compliance.kyc', hasAccess: canAccessCompliance },
    { title: 'IPS', name: 'compliance.ips', hasAccess: canAccessCompliance },
    {
      title: 'Formulários',
      name: 'compliance.clients-forms',
      hasAccess: canAccessCompliance,
      children: ['compliance.form.home', 'compliance.form.settings'],
    },
    {
      title: 'Contratos',
      name: 'compliance.contracts',
      hasAccess: canAccessCompliance,
      children: [
        'compliance.contract.overview',
        'compliance.contract.models',
        'compliance.contract.kit',
      ],
    },
  ]

  return optionsRoutes.filter((item) => {
    return item.hasAccess
  })
}

export const QUESTIONS = [
  {
    titulo: 'Tipo de investidor',
    tipo_pergunta: 'opcao',
    obrigatoria: true,
    ordem: 1,
    opcoes: ['Pessoa natural', 'Pessoa jurídica'],
    section: 'Informações iniciais',
    nome_variavel: 'tipo_investidor',
  },
  {
    titulo: 'Nome completo',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 2,
    section: 'Dados pessoais',
    suggest: 'nome_cliente',
    nome_variavel: 'nome_completo',
  },
  {
    titulo: 'Data de nascimento',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 3,
    inputType: 'date_new_ux',
    startPickerOnYear: true,
    section: 'Dados pessoais',
    suggest: 'data_nascimento',
    nome_variavel: 'data_nascimento',
  },
  {
    titulo: 'Naturalidade',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 4,
    section: 'Dados pessoais',
    nome_variavel: 'naturalidade',
  },
  {
    titulo: 'Nacionalidade',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 5,
    section: 'Dados pessoais',
    nome_variavel: 'nacionalidade',
  },
  {
    titulo: 'Estado civil',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 6,
    section: 'Dados pessoais',
    suggest: 'estado_civil',
    nome_variavel: 'estado_civil',
  },
  {
    titulo: 'Nome da mãe',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 7,
    section: 'Dados pessoais',
    nome_variavel: 'nome_mae',
  },
  {
    titulo: 'Documento de identificação',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 8,
    section: 'Dados pessoais',
    suggest: 'rg',
    nome_variavel: 'documento_identificacao',
  },
  {
    titulo: 'Órgão expedidor',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 9,
    section: 'Dados pessoais',
    nome_variavel: 'orgao_expedidor',
  },
  {
    titulo: 'Número de CPF',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 10,
    inputType: 'cpf',
    section: 'Dados pessoais',
    suggest: 'cpf',
    nome_variavel: 'cpf',
  },
  {
    titulo: 'Nome do cônjuge ou companheiro',
    tipo_pergunta: 'texto',
    obrigatoria: false,
    ordem: 11,
    section: 'Dados pessoais',
    nome_variavel: 'nome_conjuge',
  },
  {
    titulo: 'CPF do cônjuge ou companheiro',
    tipo_pergunta: 'texto',
    obrigatoria: false,
    ordem: 12,
    section: 'Dados pessoais',
    nome_variavel: 'cpf_conjuge',
  },
  {
    titulo: 'Endereço residencial completo',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 13,
    section: 'Dados de contato',
    suggest: 'endereco',
    nome_variavel: 'endereco_residencial',
  },
  {
    titulo: 'Telefone de contato',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 14,
    inputType: 'telefone',
    section: 'Dados de contato',
    suggest: 'telefone',
    nome_variavel: 'telefone_contato',
  },
  {
    titulo: 'E-mail para correspondência',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 15,
    inputType: 'email',
    section: 'Dados de contato',
    suggest: 'email',
    nome_variavel: 'email',
  },
  {
    titulo: 'Ocupação profissional',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 16,
    section: 'Dados profissionais',
    suggest: 'profissao',
    nome_variavel: 'ocupacao_profissional',
  },
  {
    titulo: 'Entidade empregadora',
    tipo_pergunta: 'texto',
    obrigatoria: false,
    ordem: 17,
    section: 'Dados profissionais',
    nome_variavel: 'entidade_empregadora',
  },
  {
    titulo: 'CNPJ empregador',
    tipo_pergunta: 'texto',
    obrigatoria: false,
    ordem: 18,
    inputType: 'cnpj',
    section: 'Dados profissionais',
    nome_variavel: 'cnpj_empregador',
  },
  {
    titulo: 'Rendimentos',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 19,
    inputType: 'money',
    section: 'Dados profissionais',
    nome_variavel: 'rendimentos',
  },
  {
    titulo: 'Situação patrimonial',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 20,
    inputType: 'money',
    section: 'Dados profissionais',
    nome_variavel: 'patrimonio',
  },
  // {
  //   titulo: 'Perfil do investidor (PF)',
  //   tipo_pergunta: 'opcao',
  //   obrigatoria: true,
  //   ordem: 21,
  //   opcoes: [
  //     'Ultra Conservador',
  //     'Conservador',
  //     'Moderado',
  //     'Arrojado',
  //     'Ultra Arrojado',
  //     'Agressivo',
  //   ],
  //   section: 'Perfil e compliance (PF)',
  //   suggest: 'perfil',
  //   nome_variavel: 'perfil_investidor_pf',
  // },
  // {
  //   titulo: 'Você é pessoa exposta politicamente (PEP)?',
  //   tipo_pergunta: 'opcao',
  //   obrigatoria: true,
  //   ordem: 22,
  //   opcoes: ['Sim', 'Não'],
  //   section: 'Perfil e compliance (PF)',
  //   suggest: 'pep',
  //   nome_variavel: 'pep',
  // },
  {
    titulo: 'Denominação ou nome empresarial',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 30,
    section: 'Dados da pessoa jurídica',
    suggest: 'nome_cliente',
    nome_variavel: 'denominacao_empresarial',
  },
  {
    titulo: 'Controladores diretos',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 31,
    section: 'Dados da pessoa jurídica',
    nome_variavel: 'controladores_diretos',
  },
  {
    titulo: 'Administradores ou procuradores',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 32,
    section: 'Dados da pessoa jurídica',
    nome_variavel: 'administradores_procuradores',
  },
  {
    titulo: 'CNPJ da pessoa jurídica',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 33,
    inputType: 'cnpj',
    section: 'Dados da pessoa jurídica',
    suggest: 'cpf',
    nome_variavel: 'cnpj_pj',
  },
  {
    titulo: 'Endereço completo da pessoa jurídica',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 34,
    section: 'Contato da pessoa jurídica',
    suggest: 'endereco',
    nome_variavel: 'endereco_pj',
  },
  {
    titulo: 'Telefone da pessoa jurídica',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 35,
    inputType: 'telefone',
    section: 'Contato da pessoa jurídica',
    suggest: 'telefone',
    nome_variavel: 'telefone_pj',
  },
  {
    titulo: 'E-mail da pessoa jurídica',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 36,
    inputType: 'email',
    section: 'Contato da pessoa jurídica',
    suggest: 'email',
    nome_variavel: 'email_pj',
  },
  {
    titulo: 'Faturamento médio mensal',
    tipo_pergunta: 'texto',
    obrigatoria: true,
    ordem: 37,
    inputType: 'money',
    section: 'Financeiro e compliance (PJ)',
    nome_variavel: 'faturamento_medio',
  },
  // {
  //   titulo: 'Perfil do investidor (PJ)',
  //   tipo_pergunta: 'opcao',
  //   obrigatoria: true,
  //   ordem: 38,
  //   opcoes: [
  //     'Ultra Conservador',
  //     'Conservador',
  //     'Moderado',
  //     'Arrojado',
  //     'Ultra Arrojado',
  //     'Agressivo',
  //   ],
  //   section: 'Financeiro e compliance (PJ)',
  //   nome_variavel: 'perfil_investidor_pj',
  // },
  // {
  //   titulo: 'Endereço dos procuradores e indicação de PEP',
  //   tipo_pergunta: 'texto',
  //   obrigatoria: false,
  //   ordem: 39,
  //   section: 'Financeiro e compliance (PJ)',
  //   nome_variavel: 'endereco_procuradores_pep',
  // },
]

export const KYC_FORM_VALUE_SOURCES = [
  'kyc',
  'kyc_answers',
  'kycAnswers',
  'answers',
  'kycData',
  'dadosKyc',
  'dados_kyc',
  'kyc_form',
  'kycForm',
]

export const KYC_MODAL_TEXT = {
  title: 'Formulário KYC/PLD',
  success: 'Formulário salvo',
  error: 'Não foi possível salvar as informações de KYC/PLD.',
  refresh: 'Atualizar dados KYC/PLD',
  refreshSuccess: 'Dados do KYC/PLD atualizados com sucesso.',
  refreshError: 'Não foi possível atualizar os dados do KYC/PLD.',
}

export const FORM_COMPLIANCE_MAP_TYPES = {
  texto: 'text',
  numero: 'number',
  data: 'date',
  'selecao-radio': 'radio',
  selecao: 'select',
  opcao: 'select',
}

export const INVERTED_MAP_TYPES_FORM_COMPLIANCE = Object.entries(
  FORM_COMPLIANCE_MAP_TYPES
).reduce((acc, [key, value]) => {
  acc[value] = key
  return acc
}, {})

// Troca de contexto da tabela da Visão Geral (Clientes/Leads/Todos). Não é um
// filtro de coluna — por isso o switch vive junto à tabela, não no menu de
// filtros do BasePageHeader. 'clientes' é o default (esconde prospects/leads).
export const OVERVIEW_TIPO_OPTIONS = [
  { value: 'clientes', text: 'Clientes' },
  { value: 'leads', text: 'Leads' },
  { value: 'todos', text: 'Todos' },
]

// Recorte por status do cliente na Visão Geral (Ativos/Inativos/Todos). Mesma
// semântica do `/clientes` e do consolidador — default 'ativos', ou seja, a
// tela desconsidera inativos até que o usuário peça o contrário. A
// normalização do flag vive em `@utils/clients/normalize-ativo`.
export const OVERVIEW_STATUS_OPTIONS = [
  { value: 'ativos', text: 'Ativos' },
  { value: 'inativos', text: 'Inativos' },
  { value: 'todos', text: 'Todos' },
]

// Confirmação e aplicação do perfil sugerido pelo IPS no cadastro do
// cliente (Visão Geral do Compliance, US-2). Persistência via
// `apiComplianceDataAppCliente.aplicarPerfilRecomendado`.
export const RECOMMENDED_PROFILE = {
  tooltipTitulo: (perfil) => `Perfil recomendado pelo IPS: ${perfil}`,
  cta: 'Clique para usar o perfil recomendado',
  aria: (perfil) => `Usar perfil recomendado: ${perfil}`,
  modalTitulo: 'Usar perfil recomendado',
  modalTexto: ({ nome, atual, recomendado }) =>
    `O perfil de ${nome} será alterado de ${
      atual || 'não definido'
    } para ${recomendado}, recomendado pelo IPS.`,
  modalConfirmar: 'Usar recomendado',
  modalCancelar: 'Cancelar',
  erroDadosInvalidos:
    'Não foi possível identificar o cliente ou o perfil recomendado. Recarregue a página e tente novamente.',
  erroInesperado:
    'Não foi possível alterar o perfil. Tente novamente mais tarde ou contate o suporte.',
}

// [Q-0753] Deep link `?clientId=` na tela de Contratos: o cliente ENTROU em
// foco, mas o formulário de contrato dele não pôde abrir. A US-10 proíbe "um
// link que perde o cliente em silêncio" — e a guarda de IPS/KYC do formulário
// só devolvia um snack, que some antes de a tela terminar de carregar. O caso
// genérico ("o cliente do link não está na carteira") vive no mixin
// `@modules/navegacao-v2/mixins/foco-cliente-deep-link`, que é de quem a
// mecânica é. Mensagem com solução, nunca só o motivo.
export const DEEP_LINK_CLIENTE_TEXT = {
  bloqueadoParaContrato: (nome, motivo) =>
    `O formulário de contrato de ${nome} não foi aberto. ${motivo} Resolva a pendência na tela correspondente e volte aqui.`,
}

export { KYC_FORM_SECTIONS } from '@modules/crm/constants/Text.js'
